import React, { useState, createContext, useRef } from 'react';

// create context
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [activeButton, setActiveButton] = useState("");
  const resultsPerPage = 5;
  const [limitData, setLimitData] = useState(20);
  const [isBulkDrawerOpen, setIsBulkDrawerOpen] = useState(false);
  const [lang, setLang] = useState('');
  const [time, setTime] = useState('');
  const [sortedField, setSortedField] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState(null);
  const [seakeyword, setSeaKeyword] = useState();
  const [zone, setZone] = useState('');
  const [status, setStatus] = useState('1');
  const [testStatus,setTestStatus] = useState('');  
  const [source, setSource] = useState('');
  const [category, setCategory] = useState(0);
  const [displayTemplates,setDisplayTemplates] = useState([]);
  const [reportType, setReportType] = useState('');
  const [CustomersGroup, setcustomergroup] = useState(0);
  const searchRef = useRef('');
  const customerRef = useRef('');

  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const closeDrawer = () => setIsDrawerOpen(false);
  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  const closeModal = () => setIsModalOpen(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const closeBulkDrawer = () => setIsBulkDrawerOpen(false);
  const toggleBulkDrawer = () => setIsBulkDrawerOpen(!isBulkDrawerOpen);

  const handleChangePage = (p) => {
    setCurrentPage(p);
  };

  const handleSubmitForAll = (e) => {
    e.preventDefault();
    if (!searchRef.current.value) return setSearchText(null);
    setCategory(null);
    setSearchText(searchRef.current.value);
  };

  const handleSubmitForGroup = (e) => {
    e.preventDefault();
    if (!searchRef.current.value) return setSearchText(null);
    setcustomergroup(null);
    setSearchText(customerRef.current.value);
  };
  // const value = useMemo(
  //   () => ({
  //     isSidebarOpen,
  //     toggleSidebar,
  //     closeSidebar,
  //     isDrawerOpen,
  //     toggleDrawer,
  //     closeDrawer,
  //     setIsDrawerOpen,
  //     isModalOpen,
  //     toggleModal,
  //     closeModal,
  //     isUpdate,
  //     setIsUpdate,
  //   }),

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [isSidebarOpen, isDrawerOpen, isModalOpen, isUpdate]
  // );

  return (
    <SidebarContext.Provider
      value={{
        isSidebarOpen,
        toggleSidebar,
        closeSidebar,
        isDrawerOpen,
        toggleDrawer,
        handleSubmitForGroup,
        closeDrawer,
        setIsDrawerOpen,
        isModalOpen,
        toggleModal,
        closeModal,
        isUpdate,
        setIsUpdate,
        closeBulkDrawer,
        isBulkDrawerOpen,
        toggleBulkDrawer,
        lang,
        setLang,
        currentPage,
        setCurrentPage,
        handleChangePage,
        searchText,
        setSearchText,
        category,
        setCategory,
        searchRef,
        handleSubmitForAll,
        status,
        setStatus,
        zone,
        setZone,
        time,
        setTime,
        sortedField,
        setSortedField,
        source,
        setSource,
        resultsPerPage,
        limitData,
        setLimitData,
        setcustomergroup,
        reportType,
        setReportType,
     seakeyword, setSeaKeyword,
     displayTemplates,
     setDisplayTemplates,
     testStatus,
     setTestStatus,
     activeButton,
     setActiveButton,selectedOrder, setSelectedOrder
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
